<template>
    <b-form @submit="onSubmit" autocomplete="off" class="form-horizontal">
        <!-- Page title -->
        <b-row>
            <b-col md="12">
                <h3 class="text-themecolor">Order <span v-if="command.id">{{$t('klantrelaties.bewerker')}}</span><span v-else>{{$t('klantrelaties.aanmaker')}}</span></h3>
            </b-col>
        </b-row>
        <!-- Page title -->
        
        <!-- Form content -->
        <b-row>
            <b-col lg="12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{$t('order.factuurgegevens')}}</h4>
                        
                        <b-form-group label-cols :label="$t('order.administratie')">
                            <b-form-select v-model="command.administrationId" :disabled="!administrations.length > 0">
                                <option value="">--- {{$t('order.maakeenkeuze')}} ---</option>
                                <option v-for="item in administrations" v-bind:key="item.id" :value="item.id">
                                    {{ item.name }}
                                </option>
                            </b-form-select>
                            <validation element="administration_id" :message="$t('validatie.geefeenadministratieop')" />
                        </b-form-group>    

                        <b-form-group label-cols :label="$t('datatables.relatie')">
                            <selectize ref="customerRelation" v-model="customerRelationId" :settings="selectizeSettings" :placeholder="$t('datatables.zoeken')"></selectize>
                        </b-form-group>         

                        <b-form-group label-cols :label="$t('order.contactpersonen')">
                            <selectize v-model="command.contactPersonIds" :settings="settingsMultiOption" :placeholder="$t('order.contactpersonen')" :disabled="contactPersons.length == 0">
                                <option v-for="item in contactPersons" v-bind:key="item.id" :value="item.id">
                                    {{ item.fullName }}
                                </option>
                            </selectize>
                        </b-form-group>

                        <b-form-group label-cols label="Referentie" v-if="command.id">
                            <b-form-input type="text" placeholder="Referentie"  v-model="command.reference"/>
                        </b-form-group>

                        <b-form-group label-cols label="Factuurnummer" v-if="command.id">
                            <b-form-input type="text" placeholder="Factuurnummer"  v-model="command.invoiceNumber"/>
                        </b-form-group>     
                    </div>
                </div>
            </b-col>
            <b-col lg="12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{$t('order.opleveringsinformatie')}}</h4>

                        <b-form-group label-cols :label="$t('order.verantwoordelijken')">
                            <selectize v-model="command.assignedUserIds" :settings="settingsMultiOption" :placeholder="$t('order.verantwoordelijken')" :disabled="!users.length > 0">
                                <option v-for="item in users" v-bind:key="item.id" :value="item.id">
                                    {{ item.fullName }}
                                </option>
                            </selectize>
                        </b-form-group>

                        <b-form-group label-cols :label="$t('order.drukkerij')">
                            <b-form-input v-model="command.printingCompany" type="text" :placeholder="$t('order.drukkerij')" />
                        </b-form-group>

                        <b-form-group label-cols :label="$t('order.verspreider')">
                            <b-form-input v-model="command.diffuser" type="text" :placeholder="$t('order.verspreider')" />
                        </b-form-group>

                        <b-form-group label-cols :label="$t('order.uitgeverij')">
                            <b-form-input v-model="command.publisher" type="text" :placeholder="$t('order.uitgeverij')" />
                        </b-form-group>   

                        <b-form-group label-cols :label="$t('order.status')">
                            <b-form-select v-model="command.status">
                                <option v-for="item in workOrderStatusses" v-bind:key="item.id" :value="item.key">
                                    {{ item.value }}
                                </option>
                            </b-form-select>
                        </b-form-group>                    
                    </div>
                </div>
            </b-col>
            <b-col lg="12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{$t('order.datums')}}</h4>

                        <b-form-group label-cols :label="$t('order.datum1eproef')">
                            <datepicker class="form-control" v-model="command.firstTestDate" placeholder="dd-mm-yyyy" />
                            <validation element="first_test_date" :message="$t('validatie.geldigedatum1eproef')" />
                        </b-form-group>

                        <b-form-group label-cols :label="$t('order.datumdrukker')">
                            <datepicker class="form-control" v-model="command.printingCompanyDate" placeholder="dd-mm-yyyy"/>
                            <validation element="printing_company_date" :message="$t('validatie.geldigedatumdrukkerij')" />
                        </b-form-group>

                        <b-form-group label-cols :label="$t('order.datumverspreider')">
                            <datepicker class="form-control" v-model="command.diffuserDate" placeholder="dd-mm-yyyy"/>
                            <validation element="diffuser_date" :message="$t('validatie.geldigedatumverspreider')" />
                        </b-form-group>                    

                        <b-form-group label-cols :label="$t('order.datumlevering')">
                            <datepicker class="form-control" v-model="command.deliveryDate" placeholder="dd-mm-yyyy"/>
                            <validation element="delivery_date" :message="$t('validatie.geldigedatumlevering')" />
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- Form content -->
        <OrderLines v-if="!command.id" id="orderLineBlock" :orderLines="orderLines" />

        <!-- Submit controls -->
        <b-row>
            <b-col md="12">
                <b-button @click="goTo(command.id ? 'detail' : 'index')" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
            </b-col>
        </b-row>
        <!-- Submit controls -->
    </b-form>
</template>
<script>
//Import store
import { mapGetters, mapActions } from 'vuex'

//Import command
import Command from './command';

//Import component
import OrderLines from "./orderlines/OrderLines";

import router from '@/providers/router/';

import $ from 'jquery';

export default {
    data () {
        var vm = this;
        return {
            command: new Command(),
            orderLines: [],
            assignedUserIds: [],
            contactPersonIds: [],
            customerRelationId: '',
            contactPersons: [],
            customerRelations: [],
            settingsMultiOption: { maxItems: 10 },
            selectizeSettings: {
                valueField: 'id',
                labelField: 'name',
                searchField: ['name', 'tag'],
                options: {},
                create: false,
                render: 
                {
                    option: function(item, escape) {
                        return '<div><strong>#' + escape(item.tag) + '&nbsp;' + escape(item.name) + '</strong><br/>' +
                            '<small class="text-muted">'+(item.address ? escape(item.address.fullAddress) : '')+'</small></div>';
                    }
                },
                load: function(query, callback) { 
                    //Check if query has length
                    if (!query.length) return callback();

                    vm.$store.dispatch('core/search',`customer-relations?query=${query}`)
                    .then((customerRelations) => {
                        callback(customerRelations);
                    })
                    .catch(() => {
                        callback();
                    })
                },
            }
        }
    },
    components: {
        OrderLines
    },
    computed: 
    {
        ...mapGetters('comceptum',['workOrder','workOrderStatusses']),
        ...mapGetters('core',['administrations','users']),
    },
    watch: {
        customerRelationId: function(customerRelationId) {
            var vm = this;
            vm.command.contactPersonIds = [];
            vm.$store.dispatch('core/search',`customer-relations/${customerRelationId}/contact-persons`)
            .then((contactPersons) => {
                vm.contactPersons = contactPersons;
            });
        }
    },
    methods: {
        ...mapActions('comceptum',['create','update']),
        onSubmit(event) {
            event.preventDefault();
            // simulate AJAX
            var vm = this;
            if(vm.orderLines.length == 0) {
                $("#orderLineBlock .card").css('border','1px solid red');
                return;
            }

            //Build reference by comma separates orderline descriptions
            var payload = {
                resource: 'workorders',
                params: vm.command
            };

            if(vm.command.id) {
                vm.update(payload)
                .then(()=> {
                    vm.goTo('detail');
                });
            }
            else {
                vm.command.reference = '';
                vm.orderLines.forEach(function(line) { vm.command.reference += line.description + ", "; });
                vm.command.reference = vm.command.reference.slice(0, -2);
                                
                vm.create(payload)
                .then((data) => {
                    router.currentRoute.params.workOrderId = data.id

                    vm.orderLines.forEach(function(orderLine) {
                        vm.create({
                            resource: 'orderlines',
                            params: orderLine
                        });
                    });

                    vm.goTo('index');
                });
            }
        },
        goTo(name) {
            this.$router.push({ name: `workorders:${name}` });
        }
    },
    created() {
        //load administrations and users per default because they must be available before the form initiates
        
        this.$store.dispatch('core/all', {
            resource: 'administrations'
        });
        this.$store.dispatch('core/all', {
            resource: 'users'
        });
    },
    mounted() {
        var vm = this;
        var item = null;

        var action = vm.$route.name.split(':')[1];
        if(action == 'update' || action == 'copy') 
        {
            var workOrderId = vm.workOrder.id;

            if(action == 'copy')
            {
                vm.workOrder.id = null;
                vm.workOrder.reference = '';
            }

            item = vm.workOrder;

            //get all contactpersons of the specified customerRelationId.
            //In that way, the user has the availability to choose between other contactpersons of the specified customerRelationId
            //Set customerrelationId, based on the first contactPerson as the customerRelationId is not being send to the API
            if(item.contactPersons != undefined) {
                if(item.contactPersons.length > 0) {
                    vm.customerRelationId = item.contactPersons[0].customerRelationId;
                    vm.$store.dispatch('core/search',`customer-relations/${vm.customerRelationId}/contact-persons`)
                    .then((contactPersons) => {
                        vm.contactPersons = contactPersons;
                        vm.command.contactPersonIds = item.contactPersons.map(x=>x.id);
                    });
                //Set the default value of the searchbox to the assigned customerRelation
                vm.$refs['customerRelation'].$el.selectize.addOption(item.contactPersons[0].customerRelation);
                vm.$refs['customerRelation'].$el.selectize.setValue(item.contactPersons[0].customerRelation, false);       
                }
            }
            //Get orderlines
            vm.$store.dispatch('comceptum/search',`workorders/${workOrderId}/lines`)
            .then((data) => {
                data.forEach(function(element) { element._showDetails = false; });
                vm.orderLines = data;
            });

            vm.command = new Command(item);
        }
    }
}
</script>